import { useEffect, useState } from "react";

/**
 * use USermedia Hook
 * @param requestedMedia - the requested media
 */
export function useUserMedia(requestedMedia: { video?: boolean; audio?: boolean }) {
	const [mediaStream, setMediaStream] = useState<MediaStream | null>(null);
	const [error, setError] = useState<unknown>(null);

	useEffect(() => {
		/**
		 * enable the stream
		 */
		async function enableStream() {
			try {
				const stream = await navigator.mediaDevices.getUserMedia(requestedMedia);
				setMediaStream(stream);
			} catch (err) {
				setError(err);
			}
		}

		if (!mediaStream) void enableStream();
		else {
			return function cleanup() {
				mediaStream.getTracks().forEach((track) => {
					track.stop();
				});
			};
		}
	}, [mediaStream, requestedMedia, setError]);

	return { stream: mediaStream, error };
}
